module.exports = __webpack_public_path__ + "static/img/11.2a63792.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/11.jpg
// module id = gjxf
// module chunks = 1